import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { ExcelOrderImport_FlowService } from './ExcelOrderImport.flow.index';
import { TransloadOrders_FlowService } from './TransloadOrders.flow.index';
import { PurchaseOrders_FlowService } from './PurchaseOrders.flow.index';
import { FootprintApiManager_FlowService } from './FootprintApiManager.flow.index';

import { app_custom_create_transload_order_line_flowService } from './app.flow.index';
import { app_custom_excel_order_importService } from './app.flow.index';
import { app_logs_writeService } from './app.flow.index';
import { app_messages_writeService } from './app.flow.index';
import { app_sftp_pullService } from './app.flow.index';
import { app_sftp_pull_and_submitService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_FlowService);
    this.TransloadOrders = this.injector.get(TransloadOrders_FlowService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_FlowService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public ExcelOrderImport: ExcelOrderImport_FlowService;
    public TransloadOrders: TransloadOrders_FlowService;
    public PurchaseOrders: PurchaseOrders_FlowService;
    public FootprintApiManager: FootprintApiManager_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _custom_create_transload_order_line_flow: app_custom_create_transload_order_line_flowService;
  public async custom_create_transload_order_line_flow(inParams: { orderId: number, shipmentId: number, packagingId: number, packagedAmount: number, materialId?: number, lotId?: number, vendorlotId?: number, notes?: string, weightOrdered?: number, cubeOrdered?: number }): Promise< { reasons?: string[], linenumber?: number, confirm?: boolean }> {
    if(!this._custom_create_transload_order_line_flow) { 
      this._custom_create_transload_order_line_flow = this.injector.get(app_custom_create_transload_order_line_flowService);
    }
    return this._custom_create_transload_order_line_flow.run(inParams);
  }
   
   

   
 
  private _custom_excel_order_import: app_custom_excel_order_importService;
  public async custom_excel_order_import(inParams: { excel_file_blob: Blob }): Promise< { results?: any[] }> {
    if(!this._custom_excel_order_import) { 
      this._custom_excel_order_import = this.injector.get(app_custom_excel_order_importService);
    }
    return this._custom_excel_order_import.run(inParams);
  }
   
   

   
 
  private _logs_write: app_logs_writeService;
  public async logs_write(inParams: { input?: $frontendTypes.Utilities.Log[] }): Promise< { output?: { log_id?: string }[], success?: boolean, error?: any[] }> {
    if(!this._logs_write) { 
      this._logs_write = this.injector.get(app_logs_writeService);
    }
    return this._logs_write.run(inParams);
  }
   
   

   
 
  private _messages_write: app_messages_writeService;
  public async messages_write(inParams: { input?: $frontendTypes.Utilities.Message[] }): Promise< { output?: { message_id?: string }[], success?: boolean, error?: any[] }> {
    if(!this._messages_write) { 
      this._messages_write = this.injector.get(app_messages_writeService);
    }
    return this._messages_write.run(inParams);
  }
   
   

   
 
  private _sftp_pull: app_sftp_pullService;
  public async sftp_pull(inParams: { connection: string, source_path: string, archive_path?: string, error_path?: string, file_extension?: string, file_name?: string, sort_asc?: boolean, transaction_id?: string }): Promise< { messages?: any[], success?: boolean, files?: { file_name?: string, file_blob?: any }[] }> {
    if(!this._sftp_pull) { 
      this._sftp_pull = this.injector.get(app_sftp_pullService);
    }
    return this._sftp_pull.run(inParams);
  }
   
   

   
 
  private _sftp_pull_and_submit: app_sftp_pull_and_submitService;
  public async sftp_pull_and_submit(inParams: { integration_id: string, sftp_connection: string, sftp_path: string, sftp_extension?: string, mq_connection?: string }): Promise< { messages?: any[] }> {
    if(!this._sftp_pull_and_submit) { 
      this._sftp_pull_and_submit = this.injector.get(app_sftp_pull_and_submitService);
    }
    return this._sftp_pull_and_submit.run(inParams);
  }
   
   

   
}
